var _path;

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.606 6.494L19.19 4.91a1.707 1.707 0 012.421 0l13.884 13.877a1.707 1.707 0 010 2.421L21.612 35.091a1.707 1.707 0 01-2.42 0l-1.586-1.585a1.716 1.716 0 01.028-2.45l8.606-8.2H5.714A1.71 1.71 0 014 21.144v-2.286c0-.95.764-1.714 1.714-1.714H26.24l-8.606-8.199a1.704 1.704 0 01-.028-2.45z"
  })));
}

export default SvgArrowRight;